import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class StylesheetsService {
  private url = 'stylesheets';
  constructor(private httpClient: HttpClientService) {}

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }
  searchOptions(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }
  create(params: any = {}): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, params);
  }
  show(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/${params.id}.json`, params);
  }
  delete(params: any = {}): Promise<any> {
    return this.httpClient.delete(`${this.url}/${params.id}.json`);
  }
  update(params: any = {}): Promise<any> {
    return this.httpClient.put(`${this.url}/${params.id}.json`, params);
  }
}
